module.exports = __webpack_public_path__ + "static/9ad44424-8f69-42db-95b4-6a99f85605b9-700.74be6c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-michael-and-all-angels/9ad44424-8f69-42db-95b4-6a99f85605b9-700.jpg
// module id = 1167
// module chunks = 168707334958949